module.exports = __webpack_public_path__ + "static/media/tt.1b5def40.svg";